import * as types from '../actionTypes/MessageContentActionTypes';

export default function MessageContentReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case types.GET_MESSAGE_CONTENT_SUCCESS: {
            if (action.messageContent) {
                const newState = { ...state };
                const { messageContent } = action;
                newState[messageContent.id] = action.messageContent;
                return newState;
            }
            return state;
        }
        case types.GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_SUCCESS: {
            if (action.messageContent) {
                const newState = { ...state };
                const bopisHolidayMessageContent = action.messageContent;
                newState[bopisHolidayMessageContent.id] = action.messageContent;
                return newState;
            }
            return state;
        }
        default:
            return state;
    }
}
